import React from "react";
import DriverCompanyOrders from "./DriverCompanyOrders";

export default function DriverCompanyActiveOrders() {
  return <DriverCompanyOrders type="active" />;
}
